import React, { useState, useEffect } from "react";
import axios from "axios";

function App() {
  const [studentId, setStudentId] = useState("");
  const [name, setName] = useState("");
  const [students, setStudents] = useState([]);

  const handleSave = async () => {
    if (!studentId || !name) {
      alert("Please enter all details");
      return;
    }
    await axios.post("https://studentdb.ascenthub.in/student_api/saveStudent.php", { studentId, name });
    setStudentId("");
    setName("");
    fetchStudents();
  };

  const fetchStudents = async () => {
    const res = await axios.get("https://studentdb.ascenthub.in/student_api/getStudents.php");
    setStudents(res.data);
  };

  useEffect(() => {
    fetchStudents();
  }, []);

  return (
    <div style={{ padding: "20px", maxWidth: "400px", margin: "auto" }}>
      <h2>Student PWA</h2>
      <input
        type="text"
        placeholder="Student ID"
        value={studentId}
        onChange={(e) => setStudentId(e.target.value)}
        style={{ display: "block", marginBottom: "10px", width: "100%" }}
      />
      <input
        type="text"
        placeholder="Student Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        style={{ display: "block", marginBottom: "10px", width: "100%" }}
      />
      <button onClick={handleSave}>Save</button>
      <button onClick={() => { setStudentId(""); setName(""); }}>Cancel</button>

      <h3>All Students</h3>
      <button onClick={fetchStudents}>View</button>
      <ul>
        {students.map((s) => (
          <li key={s.id}>
            {s.studentId} - {s.name}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default App;
